import React from 'react';
import styles from './ReportSortGroupByButtonMenu.module.scss';
import { SFChip, SFDivider, SFRadio, SFText } from 'sfui';
import { ReportListQuerySortBy } from '../../../../Services/ReportService';

export type ReportListGroupedBy = 'report' | 'date';
export interface ReportListSortAndGroupValue {
  groupedBy: ReportListGroupedBy;
  sortBy: ReportListQuerySortBy;
}

export interface ReportSortGroupByButtonMenuProps {
  groupedBy: ReportListGroupedBy;
  onGroupedByChange: (g: ReportListGroupedBy) => void;
  sortBy: ReportListQuerySortBy;
  onSortByChange: (s: ReportListQuerySortBy) => void;
}

export const ReportSortGroupByButtonMenu = ({
  groupedBy,
  sortBy,
  onGroupedByChange,
  onSortByChange
}: ReportSortGroupByButtonMenuProps): React.ReactElement<ReportSortGroupByButtonMenuProps> => {
  return (
    <div className={styles.reportSortGroupByButtonMenu}>
      <div>
        <SFText
          className={styles.title}
          type="component-messages"
          sfColor="neutral"
        >
          GROUPED BY
        </SFText>

        <div className={styles.radioOption}>
          <SFRadio
            label="Report"
            checked={groupedBy === 'report'}
            onChange={(_e, checked) => checked && onGroupedByChange('report')}
          />
        </div>
        <div className={styles.radioOption}>
          <SFRadio
            label="Date"
            checked={groupedBy === 'date'}
            onChange={(_e, checked) => checked && onGroupedByChange('date')}
          />
        </div>
        <div className={styles.radioOption}>
          <SFRadio disabled label="Shift" />
          <SFChip label="Coming Soon" size="small" sfColor="default" />
        </div>
        <div className={styles.radioOption}>
          <SFRadio disabled label="Shift and Officer" />
          <SFChip label="Coming Soon" size="small" sfColor="default" />
        </div>
      </div>

      <SFDivider />

      <div>
        <SFText
          className={styles.title}
          type="component-messages"
          sfColor="neutral"
        >
          SORTED BY
        </SFText>

        <div className={styles.radioOption}>
          <SFRadio
            label="Newest"
            checked={sortBy === 'newest'}
            onChange={(_e, checked) => checked && onSortByChange('newest')}
          />
        </div>
        <div className={styles.radioOption}>
          <SFRadio
            label="Oldest"
            checked={sortBy === 'oldest'}
            onChange={(_e, checked) => checked && onSortByChange('oldest')}
          />
        </div>
      </div>
    </div>
  );
};
